module.exports = __webpack_public_path__ + "img/asian-special-1.3542b518.jpg";